const SECTIONS = [
  { id: 'home', label: 'Home', shortcut: 'g' },
  { id: 'think', label: 'How I Think' },
  { id: 'experience', label: 'Experience' },
  { id: 'projects', label: 'Case Studies', shortcut: 'p' },
  { id: 'notes', label: 'Engineering Notes' },
  { id: 'exploring', label: 'Currently Exploring' },
  { id: 'achievements', label: 'Achievements' },
  { id: 'contact', label: 'Contact', shortcut: 'c' },
];

export default SECTIONS;
